<template>
  <span :class="classList" role="status">
    <span class="visually-hidden">Loading...</span>
  </span>
</template>

<script>
export default {
  name: 'BSpinner',
  props: {
    variant: { type: String, default: '' },
    small: { type: Boolean, default: false },
    type: { type: String, default: 'border' }
  },
  computed: {
    classList() {
      const classes = [`spinner-${this.type}`]
      if (this.small) classes.push(`spinner-${this.type}-sm`)
      if (this.variant) classes.push(`text-${this.variant}`)
      return classes
    }
  }
}
</script>
